





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import * as esri from 'esri-leaflet';

@Component
export default class PopupParcel extends Vue {

    public parcelSpinnerLayer: L.Marker | null = null;
    public selectedParcelLayer: L.GeoJSON | null = null;
    public queriedPoints: L.LatLng[] = [];
    public showPopup: boolean = false;
    public selectedPid: string = '';

    get config() {
        return this.$store.state.config;
    }

    get map(): L.Map {
        return this.$store.state.map;
    }

    get selectedParcel() {
        return this.$store.state.parcels.selectedParcel;
    }

    get selectedParcelDetail() {
        return this.$store.state.parcels.selectedParcelDetail;
    }

    get civicAddresses() {
        if (this.$store.state.parcels.selectedParcelDetail &&
            this.$store.state.parcels.selectedParcelDetail.ParcelData &&
            this.$store.state.parcels.selectedParcelDetail.ParcelData.CivicAddresses.length) {
            return this.$store.state.parcels.selectedParcelDetail.ParcelData.CivicAddresses;
        }
        return [];
    }

    get isMapClickDisabled() {
        return this.$store.state.isMapClickDisabled;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'parcelClick') {
            this.onMapParcelClick(action.payload);
        }
        if (action.type === 'parcelDataError') {
            this.onMapParcelDataRetrievedError();
        }
    });

    public showParcelDetails() {
        console.log('PopupParcel: showParcelDetails()');
        this.$store.dispatch('showParcelDialog');
    }

    public onMapParcelClick(latLon: L.LatLng) {
        console.log('_onMapParcelClick');
        if (this.isMapClickDisabled) {
            return;
        }

        this.$store.dispatch('setSelectedParcelDetail', null);

        if (this.parcelSpinnerLayer) {
            this.parcelSpinnerLayer.removeFrom(this.map);
        }

        const lSpinnerMarker = L.divIcon({
            className: '',
            iconSize: [28, 28],
            html: `<span style='color:#00458b'><i class='fas fa-spinner fa-spin fa-2x'></i></span>`,
        });

        this.parcelSpinnerLayer = L.marker(latLon, { icon: lSpinnerMarker }).addTo(this.map);

        this.queriedPoints.push(latLon);

        const lParcelQuery = esri.query({
            url: this.config.ParcelsLayer.url,
        });

        lParcelQuery.intersects(latLon).run(this.onGetParcelAtPoint);

    }

    public onGetParcelAtPoint(error: any, featureCollection: any) {
        console.log('onGetParcelAtPoint');

        if (error || !featureCollection.features.length) {
            if (this.parcelSpinnerLayer) {
                this.parcelSpinnerLayer.removeFrom(this.map);
            }
            if (this.selectedParcelLayer) {
                this.selectedParcelLayer.removeFrom(this.map);
            }
            return;
        }

        let lFeature = null;
        if (!error) {
            lFeature = featureCollection.features[0];
        }

        let lClickPoint = null;
        if (this.queriedPoints.length > 0) {
            lClickPoint = this.queriedPoints.pop();
        }

        if (lClickPoint) {
            this.showParcelPopup(lClickPoint, lFeature);
        }

        if (lFeature) {
            this.onMapParcelRetrieved(lFeature); // parcel recieved, NOT parcelDetail
            const lPid = lFeature.properties.PID.padStart(8, '0');
            this.$store.dispatch('getParcelData', lPid); // now retrieve parcelDetail
        }
    }

    public onMapParcelRetrieved(feature: any) {
        // Logger.writeLog("onMapParcelRetrieved");
        console.log('onMapParcelRetrieved');

        this.$store.dispatch('setSelectedParcel', feature);

        if (this.parcelSpinnerLayer) {
            this.parcelSpinnerLayer.removeFrom(this.map);
        }

        if (this.selectedParcelLayer) {
            this.selectedParcelLayer.removeFrom(this.map);
        }

        if (feature) {
            this.selectedParcelLayer = L.geoJSON(feature, {
                style: this.config.highlightedListingColor,
            }).addTo(this.map);
        }
    }

    public showParcelPopup(clickPoint: L.LatLng, feature: any) {
        if (!feature) {
            return;
        }

        this.selectedPid = feature.properties.PID;
        this.showPopup = true;
        // Old popup
        // let lHtml =
        // `<div id=\"parcelAddress\" style=\"display:none;margin-bottom:5px;padding-top: 5px;background:
        // #e7e7e7;border-radius: 5px;font-size: 11px;color:#545454;text-align:center;font-style:italic\"></div>`;
        // lHtml += `<div style=\"margin-bottom:15px;text-align:center;font-size: 12px;color:#545454\">PID: <b>${parcelPopupPid}</b></div>`;
        // lHtml +=
        // `<div style=\"text-align:center;width:120px\"><button id=\"btnViewParcelDetails\" type=\"button\" class=\"ViewParcelDetails btn btn-primary has-spinner spinit disabled\" >
        // <i class=\"fa fa-spinner fa-spin\"></i></button></div>`;
        // lHtml += `<div id=\"lblNoParcelData\" style=\"display:none;font-size: 15px;color:#0043ff;text-align:center;\"><b>No Parcel Data Available</b></div>`;

        L.popup({
            maxWidth: 121,
            minWidth: 121,
        })
        .setLatLng(clickPoint)
        .setContent(this.$el as HTMLElement)
        .openOn(this.map);
    }

    public onMapParcelDataRetrievedError() {
        this.selectedPid = ''; // makes popup show "no data"
    }

    public mounted() {
        console.log('PopupParcel: mounted()');
    }

}

